import { render, staticRenderFns } from "./addLection.vue?vue&type=template&id=274e6d7b&"
import script from "./addLection.vue?vue&type=script&lang=js&"
export * from "./addLection.vue?vue&type=script&lang=js&"
import style0 from "./addLection.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports